import React, { useMemo } from "react";
import { useSuperAdminUserRole } from "../../../../context/SuperAdmin/UserRoleContext";
import {
  Checkbox,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledTableCell } from "../../../../ui-components/StyledTables";
import RowSIngleUserRole from "./RowSIngleUserRole";
import { useAuthContext } from "../../../../hooks/Auth";

const SingleRoleUsersTable = () => {
  const { toDeleteUsers, setToDeleteUsers, usersByRol, searchQuery } =
    useSuperAdminUserRole();
  const { canAccess } = useAuthContext();
  const isNotProfessor =
    canAccess("delete:roleApps") && canAccess("create:roleApps");

  const filteredUsers = useMemo(() => {
    const normalizedSearch = searchQuery.toLowerCase().trim();
    if (!normalizedSearch) return usersByRol;
    return usersByRol.filter(
      (user) =>
        user.nombres?.toLowerCase().includes(normalizedSearch) ||
        user.apellidos?.toLowerCase().includes(normalizedSearch) ||
        user.email?.toLowerCase().includes(normalizedSearch)
    );
  }, [usersByRol, searchQuery]);

  const selectAll = () => {
    setToDeleteUsers(filteredUsers.map((user) => user.id_usuario_rol));
  };

  // Manejar selección/deselección de un permiso
  const handleSelect = (id: string) => {
    setToDeleteUsers((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
        mt: 2,
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            {isNotProfessor && (
              <StyledTableCell sx={{ maxWidth: "100px", width: 50 }}>
                <Checkbox
                  color="primary"
                  checked={
                    toDeleteUsers.length > 0 &&
                    toDeleteUsers.length === filteredUsers.length
                  } // Check general
                  onChange={(e) => {
                    if (e.target.checked) {
                      selectAll();
                    } else {
                      setToDeleteUsers([]);
                    }
                  }}
                  sx={{
                    color: "white", // Color del checkbox cuando no está seleccionado
                    "&.Mui-checked": {
                      color: "white", // Color del icono cuando está seleccionado
                    },
                    "& .MuiSvgIcon-root": {
                      border: "2px solid white", // Borde blanco alrededor del checkbox
                      borderRadius: "4px", // Bordes redondeados
                    },
                  }}
                />
              </StyledTableCell>
            )}
            <StyledTableCell>N°</StyledTableCell>
            <StyledTableCell>Nombres</StyledTableCell>
            <StyledTableCell>Apellidos</StyledTableCell>
            <StyledTableCell>Email</StyledTableCell>
            <StyledTableCell>Fecha de adición</StyledTableCell>
          </TableRow>
        </TableHead>

        {/* Cuerpo de la tabla */}
        <TableBody>
          {filteredUsers.length ? (
            filteredUsers.map((user, index) => (
              <RowSIngleUserRole
                key={user.id_usuario_rol}
                user={user}
                index={index}
                isSelected={toDeleteUsers.includes(user.id_usuario_rol)}
                handleSelect={handleSelect}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No se encontraron usuarios
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SingleRoleUsersTable;
